// ======================================================
// ✅ BotonTema.jsx – Alternancia de Tema (Claro / Oscuro)
// Autor: Breyner Javier Montalvo Peñarredonda
// ------------------------------------------------------
// Alterna dinámicamente entre temas claro y oscuro con
// animación suave, persistencia en contexto y soporte
// accesible para usuarios con teclado.
// ======================================================

import { memo, useCallback, useMemo } from "react";
import { useTema } from "../context/ThemeContext";
import "../styles/BotonTema.css";

const BotonTema = memo(function BotonTema() {
  // ======================================================
  // 🎨 Contexto de tema (claro / oscuro)
  // ======================================================
  const { tema, alternarTema } = useTema();

  // ======================================================
  // 🖱 Manejar clic con memoización
  // ======================================================
  const manejarClick = useCallback(() => {
    alternarTema();
  }, [alternarTema]);

  // ======================================================
  // 🔤 Etiquetas accesibles y título dinámico
  // ======================================================
  const etiqueta = useMemo(
    () => (tema === "claro" ? "Cambiar a modo oscuro" : "Cambiar a modo claro"),
    [tema]
  );

  // ======================================================
  // 🌙 Icono dinámico
  // ======================================================
  const icono = useMemo(() => (tema === "claro" ? "🌙" : "☀"), [tema]);

  // ======================================================
  // 🧱 Render del componente
  // ======================================================
  return (
    <button
      type="button"
      className={`boton-tema ${tema}`}
      onClick={manejarClick}
      aria-label={etiqueta}
      title={etiqueta}
      aria-pressed={tema === "oscuro"}
    >
      <span
        className="boton-tema__icono"
        role="img"
        aria-hidden="true"
      >
        {icono}
      </span>
    </button>
  );
});

BotonTema.displayName = "BotonTema";
export default BotonTema;
